import { WithThemeType } from "@motain/web-shared-hub/types";
import styled from "styled-components";
import { limit } from "@motain/web-shared-hub/ui/elements";

export const PageLayoutContainerOutletWrapper = styled.div<WithThemeType>`
  ${limit};
  min-height: 100vh;
`;
